const CURRENT_VS_WALLTIMORE = 1
const CURRENT_VS_ORIGINAL = 2
const WALLTIMORE_VS_ORIGINAL = 3

module.exports = {
    CURRENT_VS_WALLTIMORE,
    CURRENT_VS_ORIGINAL,
    WALLTIMORE_VS_ORIGINAL,
}
